import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import Footer from "../components/Footer";
import ContactCTA from "../components/ContactCTA";
import { Phone, Users, ArrowRight, Shield } from "lucide-react";

const products = [
  {
    icon: Phone,
    key: "communications",
    color: "text-textBlue",
    bgColor: "bg-blueLight",
  },
  {
    icon: Shield,
    key: "security",
    color: "text-red-600",
    bgColor: "bg-red-50",
  },
  {
    icon: Users,
    key: "aiPeopleCounting",
    color: "text-purple-600",
    bgColor: "bg-purple-50",
  },
];

export default function Products() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <>
      <div className="pt-20 bg-gradient-to-b from-white via-gray-50 to-white">
        {/* Header */}
        <section className="relative overflow-hidden bg-gradient-to-br from-[#e9f2fc] via-[#d0e7f9] to-[#c0dff7] py-16 sm:py-10 px-6 lg:px-16 md:px-8 sm:px-4">
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_right,_rgba(59,130,246,0.1),transparent_50%)]"></div>
          <div className="relative max-w-4xl mx-auto text-center">
            <span className="inline-block bg-gradient-to-r from-textBlue to-textBlueDark text-white text-sm sm:text-xs px-5 sm:px-3 py-2 sm:py-1.5 rounded-full mb-5 sm:mb-3 shadow-lg shadow-blue-200/50 animate-fade-in">
              {t("products.label")}
            </span>
            <h1 className="text-5xl lg:text-4xl md:text-3xl sm:text-2xl font-bold text-gray-900 mb-4 sm:mb-3 leading-tight animate-slide-up">
              {t("products.title")}
            </h1>
            <div className="w-24 h-1 bg-gradient-to-r from-transparent via-textBlue to-transparent mx-auto rounded-full"></div>
          </div>
        </section>

        {/* Products Grid - Like Homepage */}
        <section className="py-16 px-6 md:px-16 sm:px-4">
          <div className="max-w-7xl mx-auto">
            <div className="grid grid-cols-2 md:grid-cols-1 gap-8">
              {products.map((product, index) => {
                const Icon = product.icon;

                return (
                  <div
                    key={index}
                    className="bg-white p-8 rounded-xl shadow-md hover:shadow-lg transition-all duration-300 transform hover:-translate-y-1 cursor-pointer"
                    onClick={() => navigate(`/products/${product.key}`)}
                  >
                    <div className={`${product.bgColor} w-16 h-16 rounded-full flex items-center justify-center mb-4`}>
                      <Icon className={`w-8 h-8 ${product.color}`} />
                    </div>
                    <h3 className="text-2xl font-semibold text-gray-800 mb-3">
                      {t(`products.${product.key}.title`)}
                    </h3>
                    <p className="text-gray-600 mb-4 line-clamp-3">
                      {t(`products.${product.key}.description`)}
                    </p>
                    <div className="inline-flex items-center gap-2 text-textBlue hover:text-textBlueDark font-semibold transition-colors">
                      {t("products.viewMore")}
                      <ArrowRight className="w-4 h-4" />
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </section>

        <ContactCTA />
        <Footer />
      </div>
    </>
  );
}
